import React from 'react';
import clsx from 'clsx';
import { Container, Menu } from 'semantic-ui-react';
import OmniSearch from '@/search/components/OmniSearch';
import HomeLink from '@/home/components/HomeLink';
import UserProfileDropdown from '@/users/containers/UserProfileDropdown';
import Selectors from '@/layout/hooks/selectors';
import RibbonToggle from './RibbonToggle';
import HelpLink from './HelpLink';
import ExternalLinksDropdown from './ExternalLinksDropdown';
import LoginMenuItem from './LoginMenuItem';
import PartnerLink from './PartnerLink';

const NavBar = () => {
  const state = Selectors.useNavBar();
  return (
    <div className={clsx('aridhia-nav-bar', `aridhia-theme-${state.theme}`)}>
      <Menu
        inverted
        className={clsx('nav fixed', 'aridhia-nav-bar-menu', {
          'full-screen': state.fullscreen,
          'no-full-screen': !state.fullscreen,
        })}
      >
        <Container>
          <div className="flex">
            <HomeLink />
            <ExternalLinksDropdown />
            <PartnerLink />
          </div>
          <OmniSearch category="omnisearch" />
          <Menu.Menu position="right">
            <HelpLink />
            {state.isGuest && (<LoginMenuItem />)}
            {!state.isGuest && (<UserProfileDropdown />)}
          </Menu.Menu>
        </Container>
        {state.hasRibbon && (<RibbonToggle />)}
      </Menu>
    </div>
  );
};

export default NavBar;
